import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue'

// Home Page
import Home from 'src/components/Dashboard/Views/Home/Home.vue'
import Login from 'src/components/Dashboard/Views/Home/Forms/Login.vue'
import AccountSetup from 'src/components/Dashboard/Views/Home/Forms/AccountSetup.vue'
import RecoverAccount from 'src/components/Dashboard/Views/Home/Forms/RecoverAccount.vue'

// Management
import ManagementLogin from 'src/components/Dashboard/Views/Home/Forms/ManagementLogin.vue'
import TrustOverview from 'src/components/Dashboard/Views/Management/TrustOverview.vue'
import RecentDistributions from 'src/components/Dashboard/Views/Management/RecentDistributions.vue'
import RecentContributions from 'src/components/Dashboard/Views/Management/RecentContributions.vue'
import AccountView from 'src/components/Dashboard/Views/Management/AccountView.vue'
import Managers from 'src/components/Dashboard/Views/Management/Managers.vue'
import ReportAssignedAccounts from 'src/components/Dashboard/Views/Management/Reports/AssignedAccounts.vue'
import ReportElectronicStatements from 'src/components/Dashboard/Views/Management/Reports/ElectronicStatements.vue'

// Forms pages
import Documents from 'src/components/Dashboard/Views/Documents.vue'
import Settings from 'src/components/Dashboard/Views/Dashboard/Settings/Settings.vue'

import Transactions from 'src/components/Dashboard/Views/Transactions.vue'

// Charts
import Statements from 'src/components/Dashboard/Views/Statements.vue'

import store from 'src/store/store.js'

const routes = [
  {
    path: '/signout',
    redirect: '/'
  },
  {
    path: '/',
    component: Home,
    children: [
      {
        path: '/',
        name: 'Login',
        component: Login
      },
      {
        path: '/firsttime',
        name: 'Account Setup',
        component: AccountSetup
      },
      {
        path: '/recoveraccount',
        name: 'Recover Account',
        component: RecoverAccount
      },
      {
        path: '/managementlogin',
        name: 'Management Login',
        component: ManagementLogin
      }
    ]
  },
  {
    path: '/dashboard',
    component: DashboardLayout,
    beforeEnter: (to, from, next) => {
      // Only route to these pages if there is client data, except for documents
      // which is designed to work as client or manager
      if ((store.state.userData && store.state.userData.clientData) || (to.path.includes('/dashboard/document') && store.state.managerData)) {
        next()
      } else {
        next('/')
      }
    },
    children: [
      {
        path: 'overview',
        name: 'Account Overview',
        component: Overview
      },
      {
        path: 'transactions',
        name: 'Transaction History',
        component: Transactions
      },
      {
        path: 'documents',
        name: 'Forms and Pamphlets',
        component: Documents
      },
      {
        path: 'statements',
        name: 'Statements',
        component: Statements
      },
      {
        path: 'settings',
        name: 'Profile Settings',
        component: Settings
      }
    ]
  },
  {
    path: '/management',
    component: DashboardLayout,
    beforeEnter: (to, from, next) => {
      if (store.state.managerData) {
        // if going to Trust Overview (possibly from Return To Management menu item)
        // clear out the client data.
        if ((to.path === '/management/trustoverview' || to.path === '/management/accountview') && store.state.userData && store.state.userData.clientData) {
          store.state.userData = null
        }
        next()
      } else {
        next('/managementLogin')
      }
    },
    children: [
      {
        path: 'managers',
        name: 'Manage Users',
        component: Managers
      },
      {
        path: 'trustoverview',
        name: 'Trust Overview',
        component: TrustOverview
      },
      {
        path: 'recentdistributions',
        name: 'Recent Distributions',
        component: RecentDistributions
      },
      {
        path: 'recentcontributions',
        name: 'Recent Contributions',
        component: RecentContributions
      },
      {
        path: 'accountview',
        name: 'View Account',
        component: AccountView
      },
      {
        path: 'settings',
        name: 'Manager Settings',
        component: Settings
      },
      {
        path: 'reports',
        name: 'Reports',
        // taken from https://github.com/vuejs/vue-router/issues/2105
        component: {
          // Inline declaration of a component that renders our <router-view>
          render: (c) => c('router-view')
        },
        children: [
          {
            path: 'assigned-accounts',
            name: 'Reports',
            component: ReportAssignedAccounts
          },
          {
            path: 'electronic-statements',
            name: 'Reports',
            component: ReportElectronicStatements
          }
        ]
      }
    ]
  },
  {path: '*', component: NotFound}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js